import React from 'react';

interface OfferStatProps {
  title: string;
  description: string;
}

const OfferStat = ({ title, description }: OfferStatProps) => (
  <div className="flex flex-col gap-1 flex-1">
    <div className="text-sm font-bold text-[#787878]">{title}</div>
    <div className="text-lg font-extrabold text-[#202020]">{description}</div>
  </div>
);

export default OfferStat;
